export default "__VITE_ASSET__Drl9kAvG__"